<template>
  <div class="exchange-container">
    <div class="tip-title">
      {{ getPageTitle }}发布
    </div>
    <div class="information-box">
      <BaseInfo
        :title="currentPageTitle"
        :form="baseInfoFormData"
        :form-data="customer"
        :form-data-detail="detail"
        @refreshData="doSearch"
      />
      <!-- 退货合同产品明细 -->
      <ReturnProductDetail
        v-if="currentPageTitle === '退货合同'"
        :title="currentPageTitle"
        :data="ReturnProductDetailData"
      />
      <!-- 换货合同产品明细 -->
      <barterConttractProductDetail
        v-if="
          currentPageTitle === '换货合同' ||
            currentPageTitle === '价外费用合同' ||
            currentPageTitle === '虚拟换货合同'
        "
        :form="baseInfoFormData"
        :title="currentPageTitle"
        :table-data="exchangeTableData"
        :form-data-detail="detail"
        :address="address"
        @changeAddress="handleChangeAddress"
      />
      <!-- 罚金合同产品明细 -->
      <PenaltyDetail
        v-if="currentPageTitle === '罚金合同'"
        :title="currentPageTitle"
        :table-data="exchangeTableData"
      />
      <!-- 附件说明 -->
      <Attachments ref="Attachments" :table-data="AttachmentsData" />
    </div>
    <div class="footer">
      <el-button
        type="default"
        class="btn-style"
        :loading="loading"
        @click="back"
      >
        返回
      </el-button>
      <el-button
        type="primary"
        class="btn-style"
        :loading="loading"
        @click="submit"
      >
        提交
      </el-button>
    </div>
  </div>
</template>
<script>
import BaseInfo from './components/baseInfo.vue';
import Attachments from './components/attachments.vue';
import ReturnProductDetail from './components/returnProductDetails.vue';
import barterConttractProductDetail from './components/barterConttractProductDetail.vue';
import PenaltyDetail from './components/penaltyDetails.vue';
import { getDetailData, changeSubmit, returnSubmit } from '@/API';
import { getReceiptInterAddressByContractId } from '@/API/international';
import { Message } from 'element-ui';
export default {
  data () {
    return {
      loading: false,
      baseInfoFormData: {},
      customer: {},
      detail: {},
      // 退货合同列表数据
      ReturnProductDetailData: {
        address: '',
        receiverName: '',
        telephone: '',
        tableData: []
      },
      // 换货合同表格数据
      exchangeTableData: [],
      // 附件说明数据
      AttachmentsData: [],
      Attachments: null,
      address: {},
      receiptAddressId: ''

    };
  },
  components: {
    BaseInfo,
    Attachments,
    ReturnProductDetail,
    barterConttractProductDetail,
    PenaltyDetail
  },
  computed: {
    getPageTitle () {
      return this.$route.query.contractType;
    },
    currentPageTitle () { // 退货合同涉及到判断所以查询当前存在退货合同字段默认返回退货合同
      return this.$route.query.contractType.includes('退货合同') ? '退货合同' : this.$route.query.contractType;
    }
  },
  mounted () {
    this.doSearch();
  },
  methods: {
    // 获取合同详情信息
    doSearch () {
      let parmas = {
        contractId: this.$route.query.contractId,
        contractType: this.$route.query.contractType
      };
      getDetailData(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.detail = json.data.detail;
          this.baseInfoFormData = json.data.base;
          this.customer = json.data.customer;
          this.ReturnProductDetailData.tableData = json.data.product;
          this.exchangeTableData = json.data.product;
          if (this.$route.query.contractType === '价外费用合同') {
            this.exchangeTableData.forEach(item => {
              item.taxRate = '';
            });
          }
          this.AttachmentsData = json.data.attachment;
          if (!this.$route.query.contractType.includes('退货合同')) {
            this.getAddress(json.data.base.id);
          }
        }
      }).catch(() => {

      });
    },
    // 获取收货地址
    getAddress (id) {
      getReceiptInterAddressByContractId(id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.ReturnProductDetailData.address = json.data.receiptAddress;
          this.ReturnProductDetailData.receiverName = json.data.receiverName;
          this.ReturnProductDetailData.telephone = json.data.receiverPhone;
          this.address = json.data;
          this.receiptAddressId = json.data && json.data.id;
          // 默认给base接口赋值
          this.baseInfoFormData.receiptAddressId = json.data && json.data.id;
        }
      }).catch(() => {

      });
    },
    handleChangeAddress (val) {
      this.address = val;
    },
    // 返回按钮
    back () {
      this.$router.back();
    },
    // 退货必填校验
    returnVerification () {
      const tableData = this.ReturnProductDetailData.tableData;
      if (tableData) {
        for (let i = 0; i < tableData.length; i++) {
          const item = tableData[i];
          if (!item.storageName && !this.$route.query.contractType.includes('退货合同(未发货)')) {
            Message.error('请输入库位');
            return false;
          }
        }
      }
      return true;
    },
    // 换货必填校验
    exchangeVerification () {
      let requiredFields = {
        assistantName: this.baseInfoFormData.assistantName,
        orderType: this.baseInfoFormData.orderType,
        salesSettlementModes: this.baseInfoFormData.salesSettlementModes,
        powerCordSpecification: this.baseInfoFormData.powerCordSpecification,
        accountPeriod: this.customer.accountPeriod,
        threePlugPowerCord: this.baseInfoFormData.threePlugPowerCord,
        netSales: this.detail.netSales,
        formTaxRate: this.baseInfoFormData.formTaxRate,
        deliveryMethod: this.detail.deliveryMethod,
        atAfterSight: this.baseInfoFormData.atAfterSight,
        postOrdetypeName: this.detail.postOrdetypeName
      };
      const errorMessages = [];
      if (this.$route.query.contractType === '价外费用合同') {
        delete requiredFields.powerCordSpecification;
        delete requiredFields.threePlugPowerCord;
        delete requiredFields.netSales;
      }
      for (const field in requiredFields) {
        if (this.isEmpty(requiredFields[field])) {
          errorMessages.push('合同信息存在必填字段未填写完成，请检查后填写');
        }
      };
      if (this.$route.query.contractType === '价外费用合同') {
        requiredFields = {
          ...requiredFields,
          powerCordSpecification: this.baseInfoFormData.powerCordSpecification,
          threePlugPowerCord: this.baseInfoFormData.threePlugPowerCord,
          netSales: this.detail.netSales
        };
      }
      this.exchangeTableData.forEach(product => {
        if (this.isEmpty(product.materialNum) ||
          this.isEmpty(product.productNum) ||
          this.isEmpty(product.taxRate) ||
          this.isEmpty(product.expectedDeliveryDate) ||
          this.isEmpty(product.freightProperties) ||
          (!product.taxRate && this.$route.query.contractType === '价外费用合同')
        ) {
          errorMessages.push('产品列表信息存在必填字段未填写完成，请检查后填写');
        }
      });

      if (errorMessages.length > 0) {
        Message.error(errorMessages[0]);
        return false;
      }

      return true;
    },
    isEmpty (val) {
      return val === null || val === undefined || val === '';
    },
    // 提交按钮
    submit () {
      this.loading = true;
      let flag = this.$route.query.contractType;
      let whetherApproved;
      if (flag.includes('退货合同')) {
        whetherApproved = this.returnVerification();
      } else if (flag === '换货合同' || flag === '虚拟换货合同' || flag === '价外费用合同') {
        whetherApproved = this.exchangeVerification();
      }
      if (!whetherApproved) {
        this.loading = false;
        return false;
      }
      let parmas = {
        base: { ...this.baseInfoFormData, accountPeriod: this.customer.accountPeriod },
        product: flag.includes('退货合同') ? this.ReturnProductDetailData.tableData : this.exchangeTableData,
        attachment: this.$refs.Attachments.multipleSelection,
        customer: this.customer,
        detail: { ...this.detail, accountPeriod: this.customer.accountPeriod },
        contractType: flag
      };
      // 更换收货地址以后,给入参的base对象入参
      if (this.address.id && this.address.id !== this.receiptAddressId) {
        parmas.base.receiptAddressId = this.address.id;
      }
      // 判断收货地址是否为空
      if (!flag.includes('退货合同')) {
        if (!this.baseInfoFormData.receiptAddressId) {
          Message.error('请选择收货地址');
          this.loading = false;
          return false;
        }
      }
      if (flag.includes('退货合同')) {
        returnSubmit(parmas).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            Message.success('发布成功');
            this.$router.replace({
              name: 'orderPersionContractList'
            });
          }
        }).catch((err) => {
          Message.error(err);
        });
      } else {
        changeSubmit(parmas).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            Message.success('发布成功');
            this.$router.replace({
              name: 'orderPersionContractList'
            });
          }
        }).catch((err) => {
          Message.error(err);
        });
      }
      this.loading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.exchange-container {
  position: relative;
  .tip-title {
    position: sticky;
    top: 0px;
    left: 0px;
    z-index: 99;
    width: 100%;
    height: 56px;
    line-height: 56px;
    margin-top: -15px;
    color: #424c57;
    font-size: 18px;
    text-align: center;
    font-weight: bold;
    background-color: #fff;
    box-shadow: 0px 4px 4px 0px rgba(3, 18, 41, 0.05);
  }
  .footer {
    width: 100%;
    height: 60px;
    line-height: 60px;
    margin-top: 12px;
    background-color: #fff;
    box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.05);
    text-align: center;
    .btn-style {
      width: 120px;
      height: 42px;
      font-size: 16px;
    }
  }
}
</style>
